import { connect } from 'react-redux';

import LearningAdminModuleSeriesTableScreen from '../components/LearningAdminModuleSeriesTableScreen';

const mapStateToProps = (state, ownProps) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

const LearningAdminModuleSeriesTableScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearningAdminModuleSeriesTableScreen);

export default LearningAdminModuleSeriesTableScreenContainer;
